<div class="filterBarTag filterBarTag--{{elRefClass}}">
  <app-ds-chip-filter
    [size]="chipFilterSize"
    [actionType]="chipActionType"
    [state]="chipFilterState"
    [options]="[
      {
        Label: label$ | async,
        Icon: icon,
        SpecialIcon: isSpecialIcon,
      }
    ]"
    (clickEvent)="clickEvent.emit()">
  </app-ds-chip-filter>
</div>
